import authService from '~/services/authService';
import { useAuthStore } from '~/stores/useAuthStore';

const authStorePlugin = {
  install(app: any, { pinia }: any) {
    const store = useAuthStore(pinia);
    authService.CallInitStore(store);

    app.config.globalProperties.$authStore = store;
  },
};

export default authStorePlugin;
